//export const nlsdomain = 'http://localhost:3090';
export const nlsdomain = "https://nonleaguesocial.co.uk";
//print(process.env["NODE_ENV"]);
//export const nlsdomainX = "https://localhost:44350";

//export const clubListEndPoint = nlsdomain + '/clubs';
export const clubListEndPoint = nlsdomain + "/api/v2/ClubApi/ClubList";
export const clubList = clubListEndPoint;
//export const clubDetailEndPoint = nlsdomain + '/clubs';
export const clubDetailEndPoint = nlsdomain + "/api/v2/ClubApi/ClubDetail/";
export const pyramidDetails = nlsdomain + "/api/PyramidApi/GetPyramid";
export const updateClubPyramidApi =
  nlsdomain + "/api/ClubApi/UpdateClubPyramid";
export const addClubApi = nlsdomain + "/api/v2/ClubApi/AddClub";
export const addClubBasicSocialApi =
  nlsdomain + "/api/v2/ClubApi/AddClubBasicSocial";
export const blogPosts = nlsdomain + "/api/BlogApi/BlogEntryList";
export const updateBlogPostIsPublished =
  nlsdomain + "/api/BlogApi/BlogEntrySetPublished";
export const createNewBlogPost = nlsdomain + "/api/BlogApi/CreateBlogEntry";
export const testCreateNewBlogPost =
  nlsdomain + "/api/BlogApi/TestCreateBlogEntry";
export const createImmediateTwitterPost =
  nlsdomain + "/api/TwitterApi/AddImmediateTweet";
